<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :key_id="keyId"
      :key_name="keyName"
      :key_status="keyStatus"
      :key_position="keyPosition"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyId="keyId"
        :keyName="keyName"
        :keyStatus="keyStatus"
        :keyPosition="keyPosition"
        :warehouseName="warehouseName"
        @openEditShelf="openEditShelf"
        @clearKey="clearKey"
      />
      <router-view
        v-if="isSysRights('Warehouse.findShelf')"
        :first_loading="firstLoading"
        :items="items"
        @openEditShelf="openEditShelf"
        @changeShelfStatus="changeShelfStatus"
        @openDeleteShelf="openDeleteShelf"
        @openPositionListEmpty="openPositionListEmpty"
        @openPrintLabel="openPrintLabel"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        v-if="!firstLoading"
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/shelf-mgr/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
      <Modal
        :modalId="'modalEditShelf'"
        :home="false"
        :loading="modalEditShelf.loading"
        :size="'lg'"
        :autoH="false"
        :max="modalEditShelf.max"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{
                modalEditShelf.type == 1
                  ? $t("warehouse.添加货架")
                  : $t("warehouse.编辑货架")
              }}
            </h6>
            <div>
              <button type="button" class="size" @click="changeSize">
                <i
                  class="fa"
                  :class="
                    modalEditShelf.max
                      ? 'fa-window-restore'
                      : 'fa-window-maximize'
                  "
                ></i>
              </button>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                class="close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="top-wrap">
              <div class="form-group row">
                <label class="col-3 col-form-label form-control-sm text-right">
                  {{ $t("warehouse.货架名称：") }}
                  <span class="tx-danger">*</span>
                </label>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    :readonly="modalEditShelf.name == $t('warehouse.默认货架')"
                    v-model.trim="modalEditShelf.name"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-3 col-form-label form-control-sm text-right">
                  {{ $t("warehouse.仓位前缀：") }}
                  <span class="tx-danger">*</span>
                </label>
                <div
                  v-if="!modalEditShelf.autoPrefix || modalEditShelf.type == 2"
                  class="col-2 d-flex align-items-center"
                >
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    :readonly="
                      (modalEditShelf.type == 2 &&
                        modalEditShelf.name == $t('warehouse.默认货架')) ||
                      (modalEditShelf.type == 1 && modalEditShelf.autoPrefix)
                    "
                    v-model.trim="modalEditShelf.prefix"
                  />
                  <span class="mg-l-5">{{ modalEditShelf.linkSymbol }}</span>
                </div>
                <div
                  v-if="modalEditShelf.type == 1"
                  class="col-3 d-flex align-items-center"
                >
                  <label class="ckbox mg-b-0">
                    <input
                      type="checkbox"
                      :checked="modalEditShelf.autoPrefix"
                      v-model="modalEditShelf.autoPrefix"
                    /><span>{{ $t("warehouse.自动生成前缀") }}</span>
                  </label>
                </div>
              </div>
              <div class="form-group row mg-b-5">
                <label class="col-3 col-form-label form-control-sm text-right">
                  {{ $t("warehouse.货架规格：") }}
                  <span class="tx-danger">*</span>
                </label>
                <div class="col-8 d-flex align-items-center">
                  <input
                    type="text"
                    class="form-control form-control-sm wd-50 tx-center tx-bold"
                    maxlength="2"
                    :readonly="
                      modalEditShelf.type == 2 &&
                      modalEditShelf.name == $t('warehouse.默认货架')
                    "
                    v-INT
                    v-model.trim="modalEditShelf.column"
                  />
                  <span class="mg-l-5 mg-r-30">{{ $t("warehouse.列") }}</span>

                  <input
                    type="text"
                    class="form-control form-control-sm wd-50 tx-center"
                    maxlength="1"
                    :readonly="
                      modalEditShelf.type == 2 &&
                      modalEditShelf.name == $t('warehouse.默认货架')
                    "
                    v-model.trim="modalEditShelf.linkSymbol"
                  />
                  <span class="mg-l-5 mg-r-30">{{
                    $t("warehouse.连接符")
                  }}</span>

                  <input
                    type="text"
                    class="form-control form-control-sm wd-50 tx-center tx-bold"
                    maxlength="2"
                    v-INT
                    :readonly="
                      modalEditShelf.type == 2 &&
                      modalEditShelf.name == $t('warehouse.默认货架')
                    "
                    v-model.trim="modalEditShelf.row"
                  />
                  <span class="mg-l-5">{{ $t("warehouse.层") }}</span>
                </div>
              </div>
              <div class="row mg-b-15">
                <div class="col-3"></div>
                <div class="col-8">
                  {{
                    $t(
                      "warehouse.(仓位号自动生成规则：仓位前缀 + 所属列 + 连接符 + 所属层； 限99列22层)"
                    )
                  }}
                </div>
              </div>
              <div
                v-if="modalEditShelf.name != $t('warehouse.默认货架')"
                class="form-group row"
              >
                <label class="col-3 col-form-label form-control-sm text-right">
                  {{ $t("warehouse.可生成仓位数量：") }}
                </label>
                <div class="col-8 d-flex align-items-center">
                  <span class="mg-r-15 tx-bold">
                    {{ modalSpaceNum }}
                    <span
                      v-if="
                        modalEditShelf.positionArr.length >= modalSpaceNum &&
                        modalSpaceNum
                      "
                      class="tx-semibold tx-12"
                      >{{ $t("warehouse.(已满)") }}</span
                    >
                  </span>
                  <button
                    v-if="
                      modalEditShelf.type == 1 ||
                      modalEditShelf.positionArr.length < modalSpaceNum
                    "
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="autoPositions"
                  >
                    {{
                      modalEditShelf.type == 1
                        ? $t("warehouse.自动生成仓位号")
                        : `${$t("warehouse.自动补全仓位号")} (${
                            modalSpaceNum - modalEditShelf.positionArr.length
                          })`
                    }}
                  </button>
                </div>
              </div>
            </div>
            <div class="list-wrap">
              <div
                class="
                  mg-b-15
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <h4>{{ $t("warehouse.仓位列表") }}</h4>
                <div>
                  <button
                    v-if="modalEditShelf.type == 2"
                    class="mg-r-5 btn btn-primary btn-sm"
                    type="button"
                    @click="exportPosition(modalEditShelf.id)"
                  >
                    {{ $t("warehouse.导出仓位号") }}
                  </button>
                  <button
                    v-if="
                      modalEditShelf.type == 2 &&
                      modalEditShelf.name != $t('warehouse.默认货架')
                    "
                    class="mg-r-5 btn btn-primary btn-sm"
                    type="button"
                    @click="openChangePositionName()"
                  >
                    {{ $t("warehouse.批量修改仓位号") }}
                  </button>
                  <button
                    v-if="modalEditShelf.name != $t('warehouse.默认货架')"
                    class="mg-r-5 btn btn-primary btn-sm"
                    type="button"
                    @click="importPosition()"
                  >
                    {{ $t("warehouse.批量导入仓位号") }}
                  </button>
                  <input
                    v-if="modalEditShelf.upload"
                    style="display: none"
                    @change="fileUpload($event)"
                    type="file"
                    id="uploadPosition"
                    accept="text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  />
                  <button
                    v-if="modalEditShelf.type == 2"
                    class="btn btn-primary btn-sm"
                    type="button"
                    @click="openModalPositionList"
                  >
                    {{ $t("warehouse.仓位使用情况") }}
                  </button>
                </div>
              </div>
              <table class="table table-striped mg-b-0">
                <thead>
                  <tr>
                    <th class="wd-300">{{ $t("warehouse.自定义仓位列表") }}</th>
                    <th class="tx-center">{{ $t("warehouse.所属列") }}</th>
                    <th class="tx-center">{{ $t("warehouse.所属层") }}</th>
                    <th>{{ $t("warehouse.操作") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="location in modalCurItems"
                    :key="location.column + '_' + location.row"
                  >
                    <td>
                      <input
                        class="form-control form-control-sm"
                        v-model.trim="location.name"
                      />
                    </td>
                    <td class="tx-center valign-middle">
                      {{ location.column }}
                    </td>
                    <td class="tx-center valign-middle">{{ location.row }}</td>
                    <td class="valign-middle">
                      <a
                        v-if="modalEditShelf.name != $t('warehouse.默认货架')"
                        class="mg-r-15 tx-danger"
                        href="javascript:;"
                        @click="modalEditDel(location)"
                        >{{ $t("warehouse.删除") }}</a
                      >
                      <a
                        v-if="modalEditShelf.type == 2 && location.itemCnt > 0"
                        class="mg-r-15 tx-info"
                        href="javascript:;"
                        @click="openModalChangeSkuPosition(location)"
                        >{{ $t("warehouse.更换仓位商品") }}</a
                      >
                      <a
                        v-if="modalEditShelf.type == 2 && location.itemCnt > 0"
                        class="tx-info"
                        href="javascript:;"
                        @click="openPostionSku(location)"
                        >{{ $t("warehouse.查询仓位商品") }}</a
                      >
                    </td>
                  </tr>
                  <tr v-if="!modalEditShelf.positionArr.length">
                    <td colspan="4" class="tx-center tx-16 tx-bold">
                      {{ $t("warehouse.还没有生成仓位") }}!
                    </td>
                  </tr>
                </tbody>
              </table>
              <innerPagination
                v-if="modalEditShelf.positionArr.length"
                :cur="modalEditShelf.page"
                :all="modalTotalPage"
                :size="3"
                :rows_per_page="modalEditShelf.rowsPerPage"
                :page_size_select="modalEditShelf.pageSizeSelect"
                :total_count="modalEditShelf.positionArr.length"
                @changeRPPage="modalEditShelfChangeRPPage"
                @page="modalEditShelfGotoPage"
              ></innerPagination>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                v-if="modalEditShelf.name != $t('warehouse.默认货架')"
                type="button"
                class="
                  mg-r-30
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveShelf"
              >
                {{ $t("warehouse.保存") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("warehouse.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalDelPosition'"
        :home="false"
        :loading="modalDelPosition.loading"
        :size="'sm'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("warehouse.删除仓位") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <p>
              {{ $t("warehouse.确定要删除仓位") }}
              <span class="tx-danger">{{ modalDelPosition.name }}</span>
              {{ $t("warehouse.么？") }}
            </p>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-danger
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="confirmDelPosition()"
              >
                {{ $t("warehouse.删除") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("warehouse.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalDelShelf'"
        :home="false"
        :loading="modalDelShelf.loading"
        :size="'sm'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("warehouse.删除货架") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <p>
              {{ $t("warehouse.确定要删除货架") }}
              <span class="tx-danger">{{ modalDelShelf.name }}</span>
              {{ $t("warehouse.么？") }}
            </p>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-danger
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="confirmDelShelf"
              >
                {{ $t("warehouse.删除") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("warehouse.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalPositionListEmpty'"
        :home="false"
        :loading="false"
        :size="'md'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("warehouse.空闲仓位") }}
              <span>( {{ modalPositionListEmpty.name }} )</span>
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <ul v-if="modalPositionListEmpty.items.length">
              <li
                v-for="item in modalPositionListEmpty.items"
                :key="item.id"
                class="tx-success"
              >
                {{ item.name }}
              </li>
            </ul>
            <p v-else class="tx-center tx-16">
              {{ $t("warehouse.没有空闲仓位") }}
            </p>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("warehouse.关闭") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalPositionSku'"
        :home="false"
        :loading="false"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("warehouse.仓位商品列表") }}
              <span>( {{ modalPositionSku.name }} )</span>
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <table class="table table-striped mg-b-0">
              <thead>
                <tr>
                  <th>{{ $t("warehouse.商品信息") }}</th>
                  <th>{{ $t("warehouse.仓库") }}</th>
                  <th>{{ $t("warehouse.货架") }}</th>
                  <th class="tx-center">{{ $t("warehouse.库存") }}</th>
                  <th>{{ $t("warehouse.更新时间") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in modalPositionSku.items" :key="item.id">
                  <td>
                    <div class="d-flex">
                      <div
                        class="mg-r-15 img-wrap"
                        v-lazy:background-image="item.imgUrl"
                      ></div>
                      <div style="max-width: 300px">
                        <p class="mg-b-5 tx-ellipsis1">{{ item.name }}</p>
                        <p class="mg-b-0">
                          SKU:
                          <span class="tx-gray-700 mg-r-5">{{ item.sku }}</span>
                          <a
                            v-show="item.sku"
                            class="to-clipboard tx-info mg-l-5"
                            href="javascript:;"
                            :data-clipboard-text="item.sku"
                          >
                            <i class="icon ion-clipboard"></i>
                          </a>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td>{{ item.warehouseName }}</td>
                  <td>{{ item.shelfName }}</td>
                  <td class="tx-center">{{ item.quantity }}</td>
                  <td>{{ item.timeLastUpdate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("warehouse.关闭") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      !<Modal
        :modalId="'modalPositionList'"
        :home="false"
        :loading="modalPositionList.loading"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("warehouse.仓位使用状况") }}
              <span>( {{ modalEditShelf.name }} )</span>
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div
              class="mg-b-15 d-flex justify-content-between align-items-center"
            >
              <div>
                <span>{{ $t("warehouse.仓位状态：") }}</span>
                <a
                  class="mg-r-5 btn btn-sm"
                  :class="{ 'btn-primary': !modalPositionList.empty }"
                  href="javascript:;"
                  @click="modalPositionListStatus()"
                  >{{ $t("warehouse.全部") }}</a
                >
                <a
                  class="mg-r-5 btn btn-sm"
                  :class="{ 'btn-primary': modalPositionList.empty == 2 }"
                  href="javascript:;"
                  @click="modalPositionListStatus(2)"
                  >{{ $t("warehouse.已使用") }}</a
                >
                <a
                  class="btn btn-sm"
                  :class="{ 'btn-primary': modalPositionList.empty == 1 }"
                  href="javascript:;"
                  @click="modalPositionListStatus(1)"
                  >{{ $t("warehouse.未使用") }}</a
                >
              </div>
              <div class="d-flex align-items-center">
                <span class="mg-r-5 tx-right flex-1">{{
                  $t("warehouse.搜索：")
                }}</span>
                <input
                  type="text"
                  :placeholder="$t('warehouse.仓位')"
                  class="form-control form-control-sm tx-14 flex-1"
                  @keyup.enter="searchPosition($event.target.value)"
                />
              </div>
            </div>
            <div>
              <table class="table table-striped mg-b-0">
                <thead>
                  <tr>
                    <th>{{ $t("warehouse.仓位") }}</th>
                    <th>{{ $t("warehouse.列") }}</th>
                    <th>{{ $t("warehouse.层") }}</th>
                    <th>{{ $t("warehouse.状态") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in modalPositionList.items" :key="item.id">
                    <td>{{ item.name }}</td>
                    <td>{{ item.column }}</td>
                    <td>{{ item.row }}</td>
                    <td>
                      <span
                        :class="
                          Number(item.itemCnt) ? 'tx-danger' : 'tx-success'
                        "
                        >{{
                          Number(item.itemCnt)
                            ? `${$t("warehouse.已使用")} (${item.itemCnt})`
                            : $t("warehouse.未使用")
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr v-if="!modalPositionList.items.length">
                    <td colspan="4" class="tx-center tx-16 tx-bold">
                      {{ $t("warehouse.没有符合条件的仓位！") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <innerPagination
              v-if="modalPositionList.items.length"
              :cur="modalPositionList.page"
              :all="modalPositionList.totalPage"
              :size="3"
              :rows_per_page="modalPositionList.rowsPerPage"
              :page_size_select="modalPositionList.pageSizeSelect"
              :total_count="modalPositionList.totalCount"
              @changeRPPage="modalPositionListChangeRPPage"
              @page="modalPositionListGotoPage"
            ></innerPagination>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("warehouse.关闭") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalChangeSkuPosition'"
        :home="false"
        :loading="modalChangeSkuPosition.loading"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("warehouse.更换仓位商品") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="row">
              <div class="col-3">
                {{ $t("warehouse.调出仓位：")
                }}<span class="tx-bold">{{ modalChangeSkuPosition.name }}</span>
              </div>
              <div class="col-9 d-flex align-items-center">
                <span>{{ $t("warehouse.调入仓位：") }}</span>
                <div class="mg-r-15">
                  <v-select
                    class="style-chooser"
                    :placeholder="$t('warehouse.选择货架')"
                    :filterable="false"
                    :options="modalChangeSkuPosition.options1"
                    v-model="modalChangeSkuPosition.selectShelf"
                    @search="selectShelf"
                  >
                    <template slot="no-options">
                      {{ $t("warehouse.输入要选择的货架名") }}..
                    </template>
                  </v-select>
                </div>
                <div v-show="modalChangeSkuPosition.options2.length">
                  <v-select
                    class="style-chooser"
                    :placeholder="$t('warehouse.选择仓位')"
                    :filterable="true"
                    :options="modalChangeSkuPosition.options2"
                    v-model="modalChangeSkuPosition.selectPosition"
                  >
                    <template slot="no-options">
                      {{ $t("warehouse.没有匹配的仓位") }}..
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div>
              <table class="table table-striped mg-b-0 tx-12">
                <thead>
                  <tr>
                    <th class="valign-middle wd-50">
                      <label class="mg-b-0 ckbox">
                        <input
                          type="checkbox"
                          :checked="CPAllChecked"
                          @change="changeCPAllChecked($event)"
                        />
                        <span></span>
                      </label>
                    </th>
                    <th class="valign-middle">
                      {{ $t("warehouse.商品信息") }}
                    </th>
                    <th class="valign-middle tx-center">
                      {{ $t("warehouse.库存") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in modalChangeSkuPosition.items"
                    :key="item.id"
                  >
                    <td class="valign-middle">
                      <label class="mg-b-0 ckbox">
                        <input
                          type="checkbox"
                          :checked="item.checked"
                          @change="changeCPChecked($event, index)"
                        />
                        <span></span>
                      </label>
                    </td>
                    <td>
                      <div class="d-flex">
                        <div
                          class="mg-r-15 img-wrap"
                          v-lazy:background-image="item.imgUrl"
                        ></div>
                        <div>
                          <p class="mg-b-5">{{ item.name }}</p>
                          <p class="mg-b-0">
                            SKU:
                            <span class="tx-gray-700 mg-r-5">{{
                              item.sku
                            }}</span>
                            <a
                              v-show="item.sku"
                              class="to-clipboard tx-info mg-l-5"
                              href="javascript:;"
                              :data-clipboard-text="item.sku"
                            >
                              <i class="icon ion-clipboard"></i>
                            </a>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="valign-middle tx-center">
                      {{ item.quantity }}
                    </td>
                  </tr>
                  <tr v-if="!modalChangeSkuPosition.items.length">
                    <td colspan="3" class="tx-16 tx-center">
                      {{ $t("warehouse.没有商品信息！") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveChangeSkuPosition"
              >
                {{ $t("warehouse.保存") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("warehouse.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalPrintLabel'"
        :home="false"
        :loading="modalPrint.loading"
        :size="'md'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("warehouse.打印仓位标签") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="row mg-b-15">
              <div class="col-4">
                {{ $t("warehouse.选择打印模板：") }}
              </div>
              <div class="col-6">
                <select
                  v-if="modalPrint.printArr.length"
                  class="form-control form-control-sm"
                  v-model="modalPrint.selectPrintId"
                >
                  <option value="">{{ $t("warehouse.选择打印模板") }}</option>
                  <option
                    v-for="tmp in modalPrint.printArr"
                    :key="tmp.code"
                    :value="tmp.code"
                  >
                    {{ tmp.label }}
                  </option>
                </select>
                <router-link
                  v-else
                  class="tx-info"
                  :to="{ path: '/label/' }"
                  target="_blank"
                  >{{ $t("warehouse.去设置打印标签") }}</router-link
                >
              </div>
            </div>
            <div class="row pd-b-10 border-bottom-1">
              <div class="col-4 d-flex align-items-center">
                {{ $t("warehouse.选择要打印的仓位：") }}
              </div>
              <div class="col-8 d-flex align-items-center">
                <v-select
                  class="style-chooser mg-r-30"
                  :placeholder="$t('warehouse.选择仓位')"
                  :filterable="true"
                  :options="modalPrint.positionList"
                  v-model="modalPrint.selectPosition"
                >
                  <template slot="no-options">
                    {{ $t("warehouse.没有匹配的仓位") }}..
                  </template>
                </v-select>
                <button
                  class="btn btn-sm btn-success"
                  type="button"
                  @click="addPrintposition()"
                >
                  {{ $t("warehouse.打印全部仓位") }}
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12" style="min-height: 260px">
                <table class="table table-striped mg-b-0">
                  <thead>
                    <tr>
                      <th class="valign-middle">{{ $t("warehouse.仓位") }}</th>
                      <th class="tx-center wd-100">
                        {{ $t("warehouse.打印数量") }}
                      </th>
                      <th class="wd-100"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(position, index) in modalPrint.positionArr"
                      :key="position.name"
                    >
                      <td class="valign-middle">{{ position.name }}</td>
                      <td class="valign-middle">
                        <input
                          class="form-control form-control-sm tx-center"
                          v-INT
                          v-model.number="position.num"
                        />
                      </td>
                      <td class="valign-middle tx-center">
                        <a
                          class="tx-danger tx-12"
                          href="javascript:;"
                          @click="removePrintPosition(index)"
                          >{{ $t("warehouse.移除") }}</a
                        >
                      </td>
                    </tr>
                    <tr v-if="!modalPrint.positionArr.length">
                      <td class="tx-center tx-16" colspan="3">
                        {{ $t("warehouse.没有选择要打印的仓位") }}!
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>

        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="gotoPrint"
              >
                {{ $t("warehouse.打印") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("warehouse.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalChangePositionName'"
        :home="false"
        :loading="modalChangePositionName.loading"
        :size="'md'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("warehouse.批量修改仓位号") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="row">
              <div class="col-3">{{ $t("warehouse.更新内容：") }}</div>
              <div class="col-9">
                <div class="tx-12">
                  {{ $t("warehouse.每行一个") }}
                  <span class="tx-primary">{{
                    $t("warehouse.原自定义仓位名")
                  }}</span
                  >，
                  <span class="tx-primary">{{
                    $t("warehouse.新自定义仓位名")
                  }}</span>
                  {{ $t("warehouse.（支持excel复制粘贴）") }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-3"></div>
              <div class="col-9">
                <textarea
                  class="form-control form-control-sm"
                  rows="10"
                  v-model.trim="modalChangePositionName.text"
                ></textarea>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="batChangePositionName()"
              >
                {{ $t("warehouse.修改") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("warehouse.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
    </div>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import Modal from "@components/Modal";
import { pagination, innerPagination } from "@components/pagination.js"; //分页,模态框分页

export default {
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
    innerPagination,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: 10,
      totalPage: 0,
      items: [],
      keyId: "",
      keyName: "",
      keyStatus: "",
      keyPosition: "",
      warehouseId: this.$route.query.id,
      warehouseName: "",
      modalEditShelf: {
        max: true,
        loading: false,
        type: 1, //1.新建  2.编辑
        id: "",
        name: "",
        prefix: "",
        row: "",
        column: "",
        linkSymbol: "-",
        positionArr: [],
        page: 1,
        rowsPerPage: 100,
        pageSizeSelect: [10, 20, 50, 100, 200, 500],
        upload: true,
        autoPrefix: true,
      },
      modalDelPosition: {
        loading: false,
        shelfId: "",
        id: "",
        name: "",
      },
      modalDelShelf: {
        loading: false,
        name: "",
        id: "",
      },
      modalPositionListEmpty: {
        name: "",
        items: [],
      },
      modalPositionSku: {
        name: "",
        items: [],
      },
      modalPositionList: {
        loading: false,
        items: [],
        page: 1,
        rowsPerPage: 100,
        pageSizeSelect: [10, 20, 50, 100, 200, 500],
        empty: "",
        name: "",
        totalPage: 0,
        totalCount: 0,
      },
      modalChangeSkuPosition: {
        loading: false,
        shelfId: "",
        id: "",
        name: "",
        items: [],
        options1: [],
        options2: [],
        selectShelf: null,
        selectPosition: null,
      },
      modalPrint: {
        loading: false,
        shelfId: "",
        positionArr: [],
        tempId: "",
        positionList: [],
        selectPosition: null,
        printArr: [],
        selectPrintId: "",
      },
      modalChangePositionName: {
        text: "",
      },
    };
  },
  computed: {
    modalSpaceNum() {
      //可生成仓位数
      if (isNaN(this.modalEditShelf.row)) return 0;
      if (isNaN(this.modalEditShelf.column)) return 0;
      return this.modalEditShelf.row * this.modalEditShelf.column;
    },
    modalCurItems() {
      //当前页显示数据
      let items = [];
      if (this.modalEditShelf.positionArr.length) {
        let page = this.modalEditShelf.page,
          rowsPerPage = this.modalEditShelf.rowsPerPage;
        items = this.modalEditShelf.positionArr.slice(
          (page - 1) * rowsPerPage,
          (page - 1) * rowsPerPage + rowsPerPage
        );
      }
      return items;
    },
    modalTotalPage() {
      //页数
      return Math.ceil(
        this.modalEditShelf.positionArr.length / this.modalEditShelf.rowsPerPage
      );
    },
    CPAllChecked() {
      //更换商品是否全选
      if (this.modalChangeSkuPosition.items.length) {
        let num = 0;
        this.modalChangeSkuPosition.items.forEach((e) => {
          if (e.checked) num++;
        });
        if (num == this.modalChangeSkuPosition.items.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  watch: {
    "modalEditShelf.row"() {
      if (!isNaN(this.modalEditShelf.row) && this.modalEditShelf.row > 22) {
        ShowTip(this.$t("warehouse.层数不能超过22！"), "danger");
        this.modalEditShelf.row = 22;
      }
    },
    "modalChangeSkuPosition.selectShelf": {
      handler: function () {
        this.modalChangeSkuPosition.options2 = [];
        this.modalChangeSkuPosition.selectPosition = null;
        if (!this.modalChangeSkuPosition.selectShelf) {
          return false;
        }
        this.modalChangeSkuPosition.loading = true;
        $.api_call(
          "api.Warehouse.getShelf",
          { id: this.modalChangeSkuPosition.selectShelf.code },
          (r) => {
            this.modalChangeSkuPosition.loading = false;
            if (r.ErrorCode == "9999") {
              r.Data.Results.positions.forEach((e) => {
                this.modalChangeSkuPosition.options2.push({
                  label: e.name,
                  code: e.id,
                });
              });
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(this);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      },
      deep: true,
    },
    "modalPrint.selectPosition": {
      handler: function () {
        if (!this.modalPrint.selectPosition) {
          return false;
        }
        let obj = this.modalPrint.selectPosition;
        if (
          !this.modalPrint.positionArr.some((e) => {
            return e.name == obj.label;
          })
        ) {
          this.modalPrint.positionArr.unshift({ name: obj.label, num: 1 });
        }
        this.modalPrint.selectPosition = null;
      },
      deep: true,
    },
  },
  methods: {
    changeSize() {
      this.modalEditShelf.max = !this.modalEditShelf.max;
      $("#modalEditShelf .modal-dialog").removeAttr("style");
    },
    batChangePositionName() {
      if (!this.modalChangePositionName.text) {
        ShowTip(this.$t("warehouse.请先输入更新内容"), "danger");
        return false;
      }
      let arr = this.modalChangePositionName.text.split("\n"),
        batArr = [];
      arr.forEach((e) => {
        batArr.push({
          old: e.split(/,|\s+/).shift(),
          new: e.split(/,|\s+/).pop(),
        });
      });
      batArr.forEach((n) => {
        this.modalEditShelf.positionArr.some((o) => {
          if (o.name == n.old) {
            o.name = n.new;
            return true;
          }
        });
      });
      $("#modalChangePositionName").modal("hide");
      ShowTip(this.$t("warehouse.批量替换完成,保存货架后生效"), "success");
    },
    openChangePositionName() {
      //批量修改仓位名
      this.modalChangePositionName.text = "";
      $("#modalEditShelf").modal("hide");
      $("#modalChangePositionName").modal("show");
    },
    gotoPrint() {
      if (!this.modalPrint.selectPrintId) {
        ShowTip(this.$t("warehouse.请先选择打印模板"), "danger");
        return false;
      }
      if (!this.modalPrint.positionArr.length) {
        ShowTip(this.$t("warehouse.请先选择要打印的仓位"), "danger");
        return false;
      }
      this.modalPrint.loading = true;
      let params = {
        shelfId: this.modalPrint.shelfId,
        tempId: this.modalPrint.selectPrintId,
        positionArr: this.modalPrint.positionArr,
      };
      let newWin = window.open("about:blank");
      $.api_call("api.PrintLabel.printPositionLabel", params, (r) => {
        this.modalPrint.loading = false;
        if (r.ErrorCode == "9999") {
          let printData = [];
          r.Data.Results.positionHtml.forEach((e) => {
            printData.push({ num: e.num, data: Base64.decode(e.html) });
          });
          store.set("labelHtml", printData);
          newWin.location.href =
            "/print-address.html?id=" + this.modalPrint.selectPrintId;
        } else {
          newWin.close();
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    removePrintPosition(i) {
      this.modalPrint.positionArr.splice(i, 1);
    },
    addPrintposition(type) {
      //添加到打印列表
      if (type) {
        // 添加当前选中
        if (!this.modalPrint.selectPosition) {
          ShowTip(this.$t("warehouse.请先选择仓位"), "danger");
          return false;
        }
        let obj = this.modalPrint.selectPosition;
        this.modalPrint.positionArr.push({ name: obj.label, num: 1 });
      } else {
        //添加全部
        this.modalPrint.positionArr = [];
        this.modalPrint.positionList.forEach((e) => {
          this.modalPrint.positionArr.push({ name: e.label, num: 1 });
        });
        this.modalPrint.selectPosition = null;
      }
    },
    openPrintLabel(item) {
      //打印仓位标签
      this.modalPrint = {
        loading: false,
        shelfId: item.id,
        positionArr: [],
        tempId: "",
        positionList: [],
        selectPosition: null,
        printArr: [],
        selectPrintId: "",
      };
      this.modalPrint.loading = true;
      let [api1, api2] = [true, true];
      $.api_call("api.Warehouse.listPosition", { shelfId: item.id }, (r) => {
        api1 = false;
        this.modalPrint.loading = api1 || api2;
        if (r.ErrorCode == "9999") {
          r.Data.Results.forEach((e) => {
            this.modalPrint.positionList.push({ label: e.name, code: e.id });
          });
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
      $.api_call("api.PrintLabel.getPrintInfoBySupplier", { type: 3 }, (r) => {
        api2 = false;
        this.modalPrint.loading = api1 || api2;
        if (r.ErrorCode == "9999") {
          r.Data.Results.forEach((e) => {
            this.modalPrint.printArr.push({ label: e.name, code: e.id });
          });
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
      $("#modalPrintLabel").modal("show");
    },
    saveChangeSkuPosition() {
      //保存更换仓位
      if (!this.modalChangeSkuPosition.selectShelf) {
        ShowTip(this.$t("warehouse.请选择要调入的货架"), "danger");
        return false;
      }
      if (!this.modalChangeSkuPosition.selectPosition) {
        ShowTip(this.$t("warehouse.请选择要调入的仓位"), "danger");
        return false;
      }
      let sku = [];
      this.modalChangeSkuPosition.items.forEach((e) => {
        if (e.checked) sku.push(e.sku);
      });
      if (!sku.length) {
        ShowTip(this.$t("warehouse.请选择要调出的SKU"), "danger");
        return false;
      }
      let params = {
        shelfId: this.modalChangeSkuPosition.shelfId,
        id: this.modalChangeSkuPosition.id,
        sku,
        newShelfId: this.modalChangeSkuPosition.selectShelf.code,
        newId: this.modalChangeSkuPosition.selectPosition.code,
      };
      this.modalChangeSkuPosition;
      $.api_call("api.Warehouse.changeSkuPosition", params, (r) => {
        if (r.ErrorCode == "9999") {
          this.getItems();
          $("#modalChangeSkuPosition").modal("hide");
          ShowTip(this.$t("warehouse.仓位调拨成功"), "success");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    changeCPChecked(event, index) {
      //更换仓位选择
      let s = event.target.checked;
      this.$set(this.modalChangeSkuPosition.items[index], "checked", s);
    },
    changeCPAllChecked(event) {
      //更换商品全选
      let s = event.target.checked;
      this.modalChangeSkuPosition.items.forEach((e) => {
        this.$set(e, "checked", s);
      });
    },
    selectShelf(search, loading) {
      //货架选择控件
      if (!search) return false;
      $.api_call(
        "api.Warehouse.findShelf",
        { name: search, warehouseId: this.warehouseId },
        (r) => {
          this.modalChangeSkuPosition.options1 = [];
          if (r.ErrorCode == "9999") {
            r.Data.Results.forEach((e) => {
              this.modalChangeSkuPosition.options1.push({
                label: e.name,
                code: e.id,
              });
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    openModalChangeSkuPosition(obj) {
      //更换仓位商品
      this.modalChangeSkuPosition = {
        loading: false,
        shelfId: obj.shelfId,
        id: obj.id,
        name: obj.name,
        items: [],
        options1: [],
        options2: [],
        selectShelf: "",
        selectPosition: "",
      };
      this.modalEditShelf.loading = true;
      $.api_call(
        "api.Warehouse.findsPostionSku",
        { positionId: obj.id },
        (r) => {
          if (r.ErrorCode == "9999") {
            this.modalEditShelf.loading = false;
            let data = r.Data.Results;
            data.forEach((e) => {
              e.checked = false;
              this.modalChangeSkuPosition.items.push(e);
            });
            $("#modalEditShelf").modal("hide");
            $("#modalChangeSkuPosition").modal("show");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    fileUpload(event) {
      this.modalEditShelf.loading = true;
      let file = event.target.files[0];
      if (!file) {
        //重置上传控件
        this.modalEditShelf.upload = false;
        setTimeout(() => {
          this.modalEditShelf.upload = true;
        }, 500);
        return false;
      }
      $.api_call(
        "api.Warehouse.importPosition",
        { shelfId: this.modalEditShelf.id, "@file": file },
        (r) => {
          this.modalEditShelf.loading = false;
          //重置上传控件
          this.modalEditShelf.upload = false;
          setTimeout(() => {
            this.modalEditShelf.upload = true;
          }, 500);
          if (r.ErrorCode == "9999") {
            r.Data.Results.every((e, index) => {
              if (this.modalEditShelf.positionArr.length > index) {
                this.$set(this.modalEditShelf.positionArr[index], "name", e);
                return true;
              }
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    importPosition() {
      $("#uploadPosition").click();
    },
    exportPosition(id) {
      //导出仓位xls
      this.modalEditShelf.loading = true;
      if ($("#ifilePro").length == 0) {
        $("body").append(
          '<iframe id="ifilePro" style="display:none"></iframe>'
        );
      }
      $.api_call("api.Warehouse.exportPosition", { shelfId: id }, (r) => {
        this.modalEditShelf.loading = false;
        if (r.ErrorCode == "9999") {
          document.getElementById("ifilePro").src = r.Data.Results.url;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    searchPosition(name) {
      //仓位名筛选
      this.modalPositionList.name = name;
      this.modalPositionListGotoPage(1);
    },
    modalPositionListStatus(status = "") {
      //仓位状态
      this.modalPositionList.empty = status;
      this.modalPositionListGotoPage(1);
    },
    openModalPositionList() {
      //仓位使用状况列表打开
      this.modalEditShelf.loading = true;
      this.modalPositionList.loading = false;
      this.modalPositionList.items = [];
      this.modalPositionList.page = 1;
      this.modalPositionList.empty = "";
      $.api_call(
        "api.Warehouse.listPosition",
        {
          shelfId: this.modalEditShelf.id,
          empty: this.modalPositionList.empty,
          name: this.modalPositionList.name,
          page: this.modalPositionList.page,
          rowsPerPage: this.modalPositionList.rowsPerPage,
        },
        (r) => {
          this.modalEditShelf.loading = false;
          if (r.ErrorCode == "9999") {
            this.modalPositionList.items = r.Data.Results;
            this.modalPositionList.totalPage = r.Data.Pagination.totalPage;
            this.modalPositionList.totalCount = r.Data.Pagination.totalCount;
            $("#modalEditShelf").modal("hide");
            $("#modalPositionList").modal("show");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    getModalPositionList() {
      this.modalPositionList.loading = true;
      $.api_call(
        "api.Warehouse.listPosition",
        {
          shelfId: this.modalEditShelf.id,
          empty: this.modalPositionList.empty,
          name: this.modalPositionList.name,
          page: this.modalPositionList.page,
          rowsPerPage: this.modalPositionList.rowsPerPage,
        },
        (r) => {
          this.modalPositionList.loading = false;
          if (r.ErrorCode == "9999") {
            this.modalPositionList.items = r.Data.Results;
            this.modalPositionList.totalPage = r.Data.Pagination.totalPage;
            this.modalPositionList.totalCount = r.Data.Pagination.totalCount;
            $("#modalPositionList .modal-body").scrollTop(0);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    openPostionSku(item) {
      //查询仓位产品
      this.modalEditShelf.loading = true;
      $.api_call(
        "api.Warehouse.findsPostionSku",
        { positionId: item.id },
        (r) => {
          this.modalEditShelf.loading = false;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length) {
              this.modalPositionSku.items = r.Data.Results;
              this.modalPositionSku.name = item.name;
              $("#modalEditShelf").modal("hide");
              $("#modalPositionSku").modal("show");
            } else {
              ShowTip(
                this.$t("warehouse.此仓位中没有找到符合条件的商品"),
                "danger"
              );
            }
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    openPositionListEmpty(item) {
      //查询空闲仓位
      this.loading = true;
      this.modalPositionListEmpty.name = item.name;
      this.modalPositionListEmpty.items = [];
      $.api_call(
        "api.Warehouse.listPosition",
        { shelfId: item.id, empty: 1 },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.modalPositionListEmpty.items = r.Data.Results;
            $("#modalPositionListEmpty").modal("show");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    clearKey(type) {
      this[type] = "";
      this.toPage(1);
    },
    filtrate(id, name, position, status) {
      this.keyId = id;
      this.keyName = name;
      this.keyStatus = status;
      this.keyPosition = position;
      this.toPage(1);
    },
    confirmDelShelf() {
      this.modalDelShelf.loading = true;
      $.api_call(
        "api.Warehouse.deleteShelf",
        { id: this.modalDelShelf.id },
        (r) => {
          this.modalDelShelf.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems(true);
            $("#modalDelShelf").modal("hide");
            ShowTip(this.$t("warehouse.货架删除成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    openDeleteShelf(item) {
      this.modalDelShelf = {
        loading: false,
        name: item.name,
        id: item.id,
      };
      $("#modalDelShelf").modal("show");
    },
    changeShelfStatus(item) {
      this.loading = true;
      $.api_call("api.Warehouse.changeShelfStatus", { id: item.id }, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.getItems(true);
          ShowTip(this.$t("warehouse.货架状态修改成功"), "success");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    confirmDelPosition() {
      //确认删除
      this.modalDelPosition.loading = true;
      $.api_call(
        "api.Warehouse.deletePosition",
        {
          shelfId: this.modalDelPosition.shelfId,
          id: this.modalDelPosition.id,
        },
        (r) => {
          this.modalDelPosition.loading = false;
          if (r.ErrorCode == "9999") {
            this.delPositionArr(this.modalDelPosition.name);
            this.getItems();
            ShowTip(this.$t("warehouse.仓位删除成功"), "success");
            $("#modalDelPosition").modal("hide");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    delPositionArr(name) {
      //数组内删除仓位
      this.modalEditShelf.positionArr.forEach((e, i) => {
        if (e.name == name) {
          this.modalEditShelf.positionArr.splice(i, 1);
        }
      });
      if (!this.modalCurItems.length && this.modalEditShelf.page > 1)
        this.modalEditShelf.page--;
    },
    modalEditDel(item) {
      if (item.id) {
        //已经有保存过的货架
        this.modalDelPosition = {
          loading: false,
          shelfId: this.modalEditShelf.id,
          id: item.id,
          name: item.name,
        };
        $("#modalEditShelf").modal("hide");
        $("#modalDelPosition").modal("show");
      } else {
        //没有保存过的货架
        this.modalEditShelf.loading = true;
        this.delPositionArr(item.name);
        this.modalEditShelf.loading = false;
      }
    },
    modalEditShelfChangeRPPage(rowsPerPage) {
      this.modalEditShelf.rowsPerPage = rowsPerPage;
      this.modalEditShelfGotoPage(1);
    },
    modalPositionListChangeRPPage(rowsPerPage) {
      this.modalPositionList.rowsPerPage = rowsPerPage;
      this.modalPositionListGotoPage(1);
    },
    modalEditShelfGotoPage(page) {
      this.modalEditShelf.page = page;
      $("#modalEditShelf .modal-body").scrollTop(
        $("#modalEditShelf .top-wrap").outerHeight() + 15
      );
    },
    modalPositionListGotoPage(page) {
      this.modalPositionList.page = page;
      this.getModalPositionList();
    },
    saveShelf() {
      if (this.modalEditShelf.autoPrefix && this.modalEditShelf.type == 1) {
        this.modalEditShelf.prefix = this.warehouseId;
      }
      //保存货架
      if (!this.modalEditShelf.name) {
        ShowTip(this.$t("warehouse.货架名称不能为空！"), "danger");
        return;
      }
      if (!this.modalEditShelf.prefix) {
        ShowTip(this.$t("warehouse.仓位前缀不能为空！"), "danger");
        return;
      }
      if (!this.modalEditShelf.column) {
        ShowTip(this.$t("warehouse.列不能为空！"), "danger");
        return;
      }
      if (!this.modalEditShelf.prefix) {
        ShowTip(this.$t("warehouse.连接符不能为空！"), "danger");
        return;
      }
      if (!this.modalEditShelf.row) {
        ShowTip(this.$t("warehouse.层不能为空！"), "danger");
        return;
      }
      if (!this.modalEditShelf.positionArr.length) {
        ShowTip(this.$t("warehouse.仓位列表没有生成！"), "danger");
        return;
      }
      this.modalEditShelf.loading = true;
      let params = {
        warehouseId: this.warehouseId,
        name: this.modalEditShelf.name,
        prefix: this.modalEditShelf.prefix,
        linkSymbol: this.modalEditShelf.linkSymbol,
        row: this.modalEditShelf.row,
        column: this.modalEditShelf.column,
        positionArr: this.modalEditShelf.positionArr,
      };
      let url =
        this.modalEditShelf.type == 1
          ? "api.Warehouse.addShelf"
          : "api.Warehouse.changeShelf";
      if (
        this.modalEditShelf.type == 2 ||
        (this.modalEditShelf.autoPrefix && this.modalEditShelf.type == 1)
      )
        params.id = this.modalEditShelf.id;
      $.api_call(url, params, (r) => {
        this.modalEditShelf.loading = false;
        if (r.ErrorCode == "9999") {
          if (this.modalEditShelf.type == 1) {
            this.toPage(1);
          } else {
            this.getItems(true);
          }
          ShowTip(
            this.modalEditShelf.type == 1
              ? this.$t("warehouse.新建货架成功！")
              : this.$t("warehouse.修改货架成功！"),
            "success"
          );
          $("#modalEditShelf").modal("hide");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    autoPositions() {
      if (!this.modalEditShelf.prefix) {
        ShowTip(this.$t("warehouse.仓位前缀不能为空！"), "danger");
        return;
      }
      if (!this.modalEditShelf.column) {
        ShowTip(this.$t("warehouse.列不能为空！"), "danger");
        return;
      }
      if (!this.modalEditShelf.prefix) {
        ShowTip(this.$t("warehouse.连接符不能为空！"), "danger");
        return;
      }
      if (!this.modalEditShelf.row) {
        ShowTip(this.$t("warehouse.层不能为空！"), "danger");
        return;
      }
      if (this.modalEditShelf.type == 1) this.modalEditShelf.positionArr = [];
      this.modalEditShelf.page = 1;
      let col = this.modalEditShelf.column;
      let row = this.modalEditShelf.row;
      for (let i = 1; col >= i; i++) {
        for (let j = 1; row >= j; j++) {
          if (this.modalEditShelf.type == 1) {
            this.modalEditShelf.positionArr.push({
              name: `${this.modalEditShelf.prefix}${this.modalEditShelf.linkSymbol}${i}${this.modalEditShelf.linkSymbol}${j}`,
              column: i,
              row: j,
            });
          } else if (
            !this.modalEditShelf.positionArr.some((e) => {
              return e.column == i && e.row == j;
            })
          ) {
            this.modalEditShelf.positionArr.push({
              name: `${this.modalEditShelf.prefix}${this.modalEditShelf.linkSymbol}${i}${this.modalEditShelf.linkSymbol}${j}`,
              column: i,
              row: j,
            });
          }
        }
      }
      if (this.modalEditShelf.type != 1) {
        //排序
        this.modalEditShelf.positionArr.sort(this.compare("row", "asce"));
        this.modalEditShelf.positionArr.sort(this.compare("column", "asce"));
      }
    },
    compare(propName, type) {
      return (obj1, obj2) => {
        let value1 = obj1[propName];
        let value2 = obj2[propName];
        if (value2 > value1) {
          return type == "asce" ? -1 : 1;
        } else if (value2 < value1) {
          return type == "asce" ? 1 : -1;
        } else {
          return 0;
        }
      };
    },
    openEditShelf(type, item) {
      this.modalEditShelf = {
        max: true,
        loading: false,
        type,
        id: "",
        name: "",
        prefix: "",
        row: "",
        column: "",
        linkSymbol: "-",
        positionArr: [],
        page: 1,
        rowsPerPage: 100,
        pageSizeSelect: [10, 20, 50, 100, 200, 500],
        upload: true,
        autoPrefix: true,
      };
      if (type == 1) {
        //自动生成前缀
        this.modalEditShelf.loading = true;
        $.api_call(
          "api.Warehouse.addShelfPrefix",
          { warehouseId: this.warehouseId },
          (r) => {
            this.modalEditShelf.loading = false;
            if (r.ErrorCode == "9999") {
              console.log(r);
              this.modalEditShelf.prefix = r.Data.Results;
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(this);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      }
      if (type == 2) {
        this.modalEditShelf.id = item.id;
        this.modalEditShelf.loading = true;
        $.api_call("api.Warehouse.getShelf", { id: item.id }, (r) => {
          this.modalEditShelf.loading = false;
          if (r.ErrorCode == "9999") {
            let data = r.Data.Results;
            this.modalEditShelf.name = data.name;
            this.modalEditShelf.prefix = data.prefix;
            this.modalEditShelf.row = data.row;
            this.modalEditShelf.column = data.column;
            this.modalEditShelf.positionArr = data.positions;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        });
      }
      $("#modalEditShelf").modal("show");
    },
    getItems(s) {
      if (!this.isSysRights("Warehouse.findShelf")) return;
      this.loading = true;
      let params = {
        id: this.keyId,
        status: this.keyStatus,
        name: this.keyName,
        warehouseId: this.warehouseId,
        position: this.keyPosition,
        page: this.page,
        rowsPerPage: this.rowsPerPage,
      };
      $.api_call("api.Warehouse.findShelf", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          if (this.warehouseId && this.items[0].warehouseName)
            this.warehouseName = this.items[0].warehouseName;
          if (this.page > r.Data.Pagination.totalPage)
            this.page = r.Data.Pagination.totalPage
              ? r.Data.Pagination.totalPage
              : 1;
          if (!s) $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({
        path: "/shelf-mgr/" + 1,
        query: this.$route.query,
      });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({
        path: "/shelf-mgr/" + num,
        query: this.$route.query,
      });
      if (page == num) {
        this.getItems();
      }
    },
  },
  mounted() {
    this.getItems();
    $(
      "#modalDelPosition, #modalPositionSku, #modalPositionList, #modalChangeSkuPosition, #modalChangePositionName"
    ).on("hidden.bs.modal", () => {
      $("#modalEditShelf").modal("show");
    });
  },
};
</script>

<style lang="less" scoped>
#modalEditShelf {
  .list-wrap {
    border-top: 1px #ddd solid;
    padding-top: 15px;
    h4 {
      margin: 0;
      font-size: 14px;
    }
  }
}
#modalPositionListEmpty {
  ul {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    flex-wrap: wrap;
    li {
      min-width: 100px;
      margin-bottom: 5px;
      margin-right: 5px;
      padding: 0 15px;
      height: 26px;
      line-height: 26px;
      border: 1px #ddd solid;
      background-color: #f6f6f6;
    }
    li:hover {
      background-color: #fff;
    }
  }
}
.img-wrap {
  width: 80px;
  height: 80px;
  background-color: #fff;
  background-size: cover;
  background-position: center;
  border: 1px #ddd solid;
}
#modalChangeSkuPosition {
  .img-wrap {
    width: 40px;
    height: 40px;
  }
}
</style>
<style>
.style-chooser .vs__search {
  min-width: 120px;
}
.style-chooser .vs__selected + .vs__search {
  min-width: 20px;
}
</style>